import axios from 'axios'

const ROUTE = '/rest/v4/projects';
const ROUTE_WORKINGHOURS = '/rest/v4/workinghours';
const CONFIG_PROJECT = '/rest/v4/configurations/projects';

export default {

  getProjectById(id) {
    return axios.get(`${ROUTE}/${id}`);
  },

  getProjects(data) {
    return axios.get(`${ROUTE}`, data);
  },

  putProject(id, data) {
    return axios.put(`${ROUTE}/${id}`, data);
  },

  createProject(data) {
    return axios.post(ROUTE, data)
  },

  createNewSubProject(id, data) {
    return axios.post(`${ROUTE}/${id}/subproject`, data)
  },

  forceDeleteProject(id) {
    return axios.delete(`${ROUTE}/${id}`, { params: { forceDelete: true } });
  },

  copyProjectById(data) {
    return axios.post(`${ROUTE}/copy`, data)
  },

  getProjectByIdShort(id) {
    return axios.get(`${ROUTE}/${id}/short`);
  },

  getProjectPhasesById(id) {
    return axios.get(`${ROUTE}/${id}/phases`);
  },

  getCurrentActions(id) {
    return axios.get(`${ROUTE}/${id}/workflows/actions`);
  },

  getWorkinghoursProjectById(id) {
    return axios.get(`${ROUTE_WORKINGHOURS}/workinghourprojects/${id}`);
  },

  getRecentlyUsedPlanningNotes(id, date, planningItemId) {
    return axios.get(`${ROUTE_WORKINGHOURS}/projects/${id}/planningnotes`, { params: { date: date, planningItemId: planningItemId } });
  },

  getInvoiceAddressByContact(addressType, contact) {
    return axios.get(`${CONFIG_PROJECT}/getinvoiceaddress`, { params: { addressType: addressType, contact: contact } })
  },

  getDashboardInfos(id) {
    return axios.get(`${ROUTE}/${id}/dashboard`);
  },

  putContactPerson(projectId, contactId) {
    return axios.put(`${ROUTE}/${projectId}/contact/${contactId}`);
  },

  putOrderNumber(projectId, orderNumber) {
    return axios.put(`${ROUTE}/${projectId}/ordernumber`, { data: orderNumber });
  },

  getCalculationItemType() {
    return axios.get(`${CONFIG_PROJECT}/calculationitemtypes/default`)
  },

  putProjectPriority(projectId, data) {
    return axios.put(`${ROUTE}/${projectId}/projectpriority`, data);
  },

  putProjectIsSelfCollector(projectId, data) {
    return axios.put(`${ROUTE}/${projectId}/selfcollector`, data);
  },

  getDeliveryCalculationItemsItems(projectId) {
    return axios.get(`${ROUTE}/${projectId}/deliverycalculationitems`);
  },

  getDefaultCountry() {
    return axios.get('/rest/v4/system/countries/default');
  },

  getProductivities() {
    return axios.get(`/rest/v4/projects/productivities`)
  },

  getCurrentDeviation(projectId) {
    return axios.get(`${ROUTE}/${projectId}/workflows/deviations/current`);
  },

  getUpdatedCalculationVersion(projectId, data) {
    return axios.post(`${ROUTE}/${projectId}/calculationversions/update-calculation-version`, data)
  },

  getNextProjectNumber(data) {
    return axios.post(`${ROUTE}/nextprojectnumber`, data);
  },

  getContracts(id) {
    return axios.get(`${ROUTE}/${id}/contracts`);
  }
}
